module.exports = __webpack_public_path__ + "static/media/img-2.5d8b912b.png";